import React from "react";

// form & validsation
import * as yup from "yup";
import { FormLabel, FormRadio, FormError, FormTextArea } from "components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { customClasses } from "styles";

// schema
const Step18schema = yup
  .object()
  .shape({
    user_details: yup
      .object()
      .shape({
        during_discussion: yup.string().required("This is a required field"),
        // if_children_care_important: yup
        //   .string()
        //   .required("This is a required field"),
        // if_asset_divide_important: yup
        //   .string()
        //   .required("This is a required field"),
        import_misc: yup.string().notRequired(),
      })
      .required(),
  })
  .required();

export function Step19({ onSubmit, store }) {
  const {
    handleSubmit,
    register,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: store,
    resolver: yupResolver(Step18schema),
  });

  const handleData = (values) => {
    const copy_data = Object.assign({}, store.user_details);
    const merger_current_values = { ...copy_data, ...values.user_details };
    const mergeToStore = { ...store, user_details: merger_current_values };
    onSubmit(mergeToStore);
  };

  return (
    <form id="divorce-form" onSubmit={handleSubmit(handleData)}>
      <section>
        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor={`user_details.during_discussion`}
            className={customClasses.questionText}
            error={errors?.user_details?.during_discussion?.message}
          >
            What is important to you during Your Discussion with our legal team?
          </FormLabel>
          <article>
            <FormRadio
              setValue={setValue}
              value="Primarily Asset Division"
              name="user_details.during_discussion"
              register={register}
            />
            <FormRadio
              setValue={setValue}
              value="Primarily Arrangements For Children"
              name="user_details.during_discussion"
              register={register}
            />
            <FormRadio
              setValue={setValue}
              value="Both Equally Important"
              name="user_details.during_discussion"
              register={register}
            />
          </article>
          <FormError error={errors?.user_details?.during_discussion?.message} />
        </section>
        {/* <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor={`user_details.if_children_care_important`}
            className={customClasses.questionText}
            error={errors?.user_details?.if_children_care_important?.message}
          >
            Making arrangements to care for your children?
          </FormLabel>
          <article>
            <FormRadio
              setValue={setValue}
              value="Yes"
              name="user_details.if_children_care_important"
              register={register}
            />
            <FormRadio
              setValue={setValue}
              value="No"
              name="user_details.if_children_care_important"
              register={register}
            />
            <FormRadio
              setValue={setValue}
              value="Unsure"
              name="user_details.if_children_care_important"
              register={register}
            />
          </article>
          <FormError
            error={errors?.user_details?.if_children_care_important?.message}
          />
        </section>
        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor={`user_details.if_asset_divide_important`}
            className={customClasses.questionText}
            error={errors?.user_details?.if_asset_divide_important?.message}
          >
            How to divide the assets of your relationship?
          </FormLabel>
          <article>
            <FormRadio
              setValue={setValue}
              value="Yes"
              name="user_details.if_asset_divide_important"
              register={register}
            />
            <FormRadio
              setValue={setValue}
              value="No"
              name="user_details.if_asset_divide_important"
              register={register}
            />
            <FormRadio
              setValue={setValue}
              value="Unsure"
              name="user_details.if_asset_divide_important"
              register={register}
            />
          </article>
          <FormError
            error={errors?.user_details?.if_asset_divide_important?.message}
          />
        </section> */}
        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor={`user_details.import_misc`}
            className={customClasses.questionText}
            error={errors?.user_details?.import_misc?.message}
          >
            Specify anything else important to you here (optional)
          </FormLabel>
          <article>
            <FormTextArea
              placeholder="Type here"
              id={`user_details.import_misc`}
              type="text"
              name={`user_details.import_misc`}
              error={errors?.user_details?.import_misc?.message}
              register={register}
            />
          </article>
          <FormError error={errors?.user_details?.import_misc?.message} />
        </section>
      </section>
    </form>
  );
}
